/* eslint-disable react-hooks/exhaustive-deps */

import { withStyles } from '@material-ui/core';

import { Box } from '@mui/material';

import { compose } from 'recompose';
import { connect } from 'react-redux';
import FullscreenSpinner from 'modules/common/fullscreenSpinner.component';
import React, { useEffect, useState } from 'react';

import { getAuthorizationAllFileLogs, getAuthorizationFileLogs } from './store/activityLog.actions';
import { GET_ACTIVITY_LOG_AUTHORIZATION_ALL_FAILURE } from './store/activityLog.types';
import { TOAST_MESSAGE_SEVERITY_ERROR } from 'modules/layout/types';
import ActivityLogComponent from './activityLog.component';
import { fetchAuthDetails, fetchEnumerations } from '../authorizations/utils/fetchDataDetailsService.js';
import { getEmailTemplateSummaries } from 'modules/emailTemplates/store/emailTemplate.actions';
import { getSurveyQuestionResponsesByAuth } from 'modules/surveys/surveys.actions';
import {
  getAuthClientPoliciesListByClient,
  getAuthorizationSummary,
  getTemporaryLivingAssignments,
  getVendors,
  setAuthId,
  updateAuthorizationSummary
} from 'modules/authorizations/authorizations.actions';
import { getInternalUsers, setLoadingComplete } from 'modules/clients/clients.actions';
import { getAuthorizationComments } from 'modules/authorizations/store/actions/authorizations.actions';
import { getAllCountries } from 'country-locale-map';
import {
  getAllCurrencies,
  getAllEnumerations,
  getAllProvinces,
  getAllSaleTypes,
  getAllWeightTypes
} from 'modules/enumerations/store/enumerationActions';
import { getCommentsAndNotes } from 'modules/authorizations/store/actions/commentsAndNotes.actions';
import { setPageTitle, showToast } from 'modules/layout/layout.actions';

const styles = theme => ({
  wideControl: {
    minWidth: 174
  },
  section: {
    marginBottom: theme.spacing(2)
  },
  selfServicePolicySelect: {
    minWidth: 300
  }
});

const AuthorizationActivityLogView = props => {
  const details = props.authorizationDetails ? props.authorizationDetails[props.match.params.id] : null;
  const [logs, setLogs] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const authId = props.match.params.id;

  useEffect(() => {
    async function fetchData() {
      setIsLoading(true);
      props.setAuthId(authId);
      await fetchEnumerations(props);
      const response = await props.getAuthorizationAllFileLogs(authId);
      if (response.type === GET_ACTIVITY_LOG_AUTHORIZATION_ALL_FAILURE) {
        props.showToast('Failed to retrieve activity logs for this authorization.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
      } else {
        setLogs(response.response);
      }

      if (!details) {
        await fetchAuthDetails(details, authId, props);
        props.setLoadingComplete();
      }

      setIsLoading(false);
    }

    fetchData();
  }, []);

  return (
    <Box>
      {!isLoading && logs && details && (
        <Box sx={{ padding: 3 }}>
          <ActivityLogComponent logs={logs} enumerations={props.enumerations ? props.enumerations.allEnums : {}} />
        </Box>
      )}
      {isLoading && <FullscreenSpinner />}
    </Box>
  );
};

const mapStateToProps = state => {
  const { authorizationDetails, isLoading } = state.authorizations;
  const enumerations = state.enumerations;
  return {
    authorizationDetails,
    isLoading,
    enumerations
  };
};

export default compose(
  withStyles(styles),
  connect(mapStateToProps, {
    getAuthorizationFileLogs,
    getAuthorizationSummary,
    getVendors,
    setPageTitle,
    showToast,
    setAuthId,
    setLoadingComplete,
    getCommentsAndNotes,
    getAuthClientPoliciesListByClient,
    updateAuthorizationSummary,
    getAllEnumerations,
    getAllSaleTypes,
    getAllWeightTypes,
    getAllProvinces,
    getAllCurrencies,
    getAllCountries,
    getAuthorizationComments,
    getInternalUsers,
    getTemporaryLivingAssignments,
    getSurveyQuestionResponsesByAuth,
    getEmailTemplateSummaries,
    getAuthorizationAllFileLogs
  })
)(AuthorizationActivityLogView);
